import { isGtmEnabled } from "../store";

const trackEvent = (eventObject, gtm = null) => {
  console.log("Event: " + eventObject.event);

  if (isGtmEnabled() && gtm) gtm.trackEvent(eventObject);
};

export { trackEvent };
